export default __webpack_public_path__ + "static/media/help-selected.a7f1f1f3.svg";